import { Customer } from './customer';
import { User } from './user';
import { Vehicle } from './vehicle';
import { Driver } from './driver';
import { Order } from './order';
import { DeliveryGroup } from './delivery-group';
import { DeliveryPoint } from './delivery-point';
import { DeliveryRoute } from './delivery-route';


export class Delivery {

    public id:number;
    public idExternal:string;

    public status:string;

    public user:User;

    public vehicle:Vehicle;
    public driver:Driver;

    public customer:Customer;
    public finalCustomer:Customer;
    
    public initDatePlanned:Date;
    public endDatePlanned:Date;

    public initDateExecuted:Date;
    public endDateExecuted:Date;

    public orders:Array<Order>;

    public plannedRoute:string;

    public configRoute:number;

    public estimatedTotalDuration:number;
    public estimatedTotalDistance:number;

    public executedTotalDuration:number;
    public executedTotalDistance:number;

    public totalWeight:number;
    public totalPrice:number;
    public totalOrder:number;
    //Sum of products of all orders
    public totalProduct:number;

    public deliveryGroup:DeliveryGroup;

    public deliveryRoutes:DeliveryRoute[];

    public collaborators:Driver[];

    public hasChanges:boolean = false;
    public hasError:boolean = false;

    public logisticCostPlanned:number;
    public logisticCostKmPlanned:number;
    public logisticCostLaborPlanned:number;
    public logisticCostTonPlanned:number;
    public logisticCostVehiclePlanned:number;
    
    public logisticCostExecuted:number;
    public logisticCostKmExecuted:number;
    public logisticCostLaborExecuted:number;
    public logisticCostTonExecuted:number;
    public logisticCostVehicleExecuted:number;

    constructor (id:number, status:string,
                    vehicle:Vehicle, driver:Driver,
                    customer:Customer, finalCustomer:Customer,
                    initDate:Date, endDate:Date, 
                    initDatePlanned:Date, endDatePlanned:Date, 
                    user:User, orders:Array<Order>,
                    plannedRoute:string, configRoute:number, idExternal:string) {
        this.id = id;
        this.idExternal = idExternal;
        this.status = status;
        this.customer = customer;
        this.finalCustomer = finalCustomer;
        this.initDatePlanned = initDatePlanned;
        this.endDatePlanned = endDatePlanned;
        this.vehicle = vehicle;
        this.driver = driver;
        this.user = user;
        this.orders = orders;
        this.plannedRoute = plannedRoute;
        this.configRoute = configRoute;

        this.collaborators = null;
        this.initDateExecuted = null;
        this.endDateExecuted = null;
    }

    // get selectedRoute():DeliveryRoute{
    //     return this.deliveryRoutes[this.configRoute-1];
    // }
    get idCustom():any {
        if (this.idExternal && this.idExternal.length > 0) {
            return this.idExternal;
        } else {
            return this.id;
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/entities/delivery.ts